<template>

    <div class="preinscriptions" v-if="dataLoaded && creationOptionsLoaded">

        <Loader v-if="isDownloading" class="loader-is-downloading" />

        <div class="new-preinscription">
            <h3>Cohortes para gestionar</h3>
            <button class="create-new" @click.stop="router.push('/createPreinscription')"><i class="material-icons">add_circle</i>Nueva cohorte</button>
        </div>

        <div class="filters">

            <!-- Select coordinator -->
            <div class="filter" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'" 
                @click="expandFilter == 'coordinator' ? expandFilter = '' : expandFilter = 'coordinator'"
            >
                <span class="filter-label">{{ params.forgeUserId ? creationOptions.coordinators.find(el=> el.id == params.forgeUserId).fullName : 'Coordinador/a' }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'coordinator'">
                    <template v-for="(coordinator, idx) in creationOptions.coordinators" :key="idx">
                        <li @click="params.forgeUserId = coordinator.id">{{ coordinator.fullName }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select referent -->
            <div class="filter" v-else-if="userData.role == 'COORDINADOR_PEDAGOGICO'"
                @click="expandFilter == 'referent' ? expandFilter = '' : expandFilter = 'referent'"
            >
                <span class="filter-label">{{ params.forgeUserId ? creationOptions.referents.find(el=> el.id == params.forgeUserId).fullName : 'Gestor/a' }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'referent'">
                    <template v-for="(referent, idx) in creationOptions.referents" :key="idx">
                        <li @click="params.forgeUserId = referent.id">{{ referent.fullName }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select country -->
            <div class="filter"
                @click="expandFilter == 'country' ? expandFilter = '' : expandFilter = 'country'"
            >
                <span class="filter-label">{{ params.country == 0 ? 'País' : creationOptions.countries.find(el=>el.id == params.country).name }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'country'">
                    <template v-for="(country, idx) in creationOptions.countries" :key="idx">
                        <li @click="params.country = country.id">{{ country.name }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select status -->
            <div class="filter"
                @click="expandFilter == 'status' ? expandFilter = '' : expandFilter = 'status'"
            >
                <span class="filter-label">{{ params.status == 'ALL' ? 'Estado' : $t(`preInscription.statusPlural.${params.status}`) }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'status'">
                    <template v-for="(status, idx) in creationOptions.status" :key="idx">
                        <li @click="params.status = status">{{ $t(`preInscription.statusPlural.${status}`) }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select courseType -->
            <div class="filter"
                @click="expandFilter == 'courseType' ? expandFilter = '' : expandFilter = 'courseType'"
            >
                <span class="filter-label">{{ params.courseType === '' ? 'Tipo' : $t(`courseInstance.courseTypes.${creationOptions.courseType.find(el=>el.id == params.courseType).name}`) }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'courseType'">
                    <template v-for="(courseType, idx) in creationOptions.courseType" :key="idx">
                        <li @click="params.courseType = courseType.id">{{ courseType.id == '' ? courseType.name : $t(`courseInstance.courseTypes.${courseType.name}`) }}</li>
                    </template>
                </ul>
            </div>

            <!-- Select targetType -->
            <div class="filter"
                @click="expandFilter == 'targetType' ? expandFilter = '' : expandFilter = 'targetType'"
            >
                <span class="filter-label">{{ params.targetType === '' ? 'Público' : creationOptions.targetType.find(el=>el.id == params.targetType).name }} <i class="material-icons filter-icon">keyboard_arrow_down</i></span>
                <ul v-if="expandFilter == 'targetType'">
                    <template v-for="(targetType, idx) in creationOptions.targetType" :key="idx">
                        <li @click="params.targetType = targetType.id">{{ targetType.name }}</li>
                    </template>
                </ul>
            </div>

        </div>

        <div ref="table" class="table-pagination">
            <div class="table__container">
                <table class="table">
                    <thead class="table__head">
                        <tr class="table__head__row">
                            <th class="table__head__row__title">COHORTE</th>
                            <th class="table__head__row__date">FECHA DE CIERRE</th>
                            <th class="table__head__row__limit">CUPO</th>
                            <th class="table__head__row__stage table__head__row__stageone" @mouseover="stageTooltip=1" @mouseleave="stageTooltip=null">ETAPA 1 <i class="material-icons-outlined">info</i>
                                <div class="stage-tooltip" v-if="stageTooltip == 1"><h4>ETAPA 1</h4><span>Es la etapa de <b>Preinscripción</b>.</span></div>
                            </th>
                            <th class="table__head__row__stage table__head__row__stagetwo" @mouseover="stageTooltip=2" @mouseleave="stageTooltip=null">ETAPA 2 <i class="material-icons-outlined">info</i>
                                <div class="stage-tooltip" v-if="stageTooltip == 2"><h4>ETAPA 2</h4><span>Es la etapa de <b>Inscripción</b>.</span></div>
                            </th>
                            <th class="table__head__row__coordinator" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'">COORDINADOR</th>
                            <th class="table__head__row__referent" v-if="userData.role == 'COORDINADOR_PEDAGOGICO'">GESTORES</th>
                            <th class="table__head__row__status">ESTADO</th>
                            <th class="table__head__row__type">TIPO</th>
                            <th class="table__head__row__type">PÚBLICO</th>
                            <th class="table__head__row__options"></th>
                            <div></div>
                        </tr>
                    </thead>
                    <tbody class="table__body">
                        <tr td="table__body__row" v-for="(row,index) in preinscriptions" :key="index">
                            <td class="table__body__row__title" @mouseover="row.titleTooltip = true" @mouseleave="row.titleTooltip = false">
                                {{row.internalName}}
                                <span class="title-tooltip" v-if="row.titleTooltip && row.internalName.length>10">{{row.internalName}}</span>
                            </td>
                            <td class="table__body__row__date">{{row.endDate ? formatDate(row.endDate) : '-'}}</td>
                            <td class="table__body__row__limit">{{row.studentLimit ? row.studentLimit : '-'}}</td>
                            <td class="table__body__row__stageone">{{row.studentStageOne}}</td>
                            <td class="table__body__row__stagetwo">{{row.studentStageTwo}}</td>
                            <td class="table__body__row__coordinator" v-if="userData.role == 'COORDINADOR_ACADEMICO' || userData.role == 'ADMINISTRADOR'">
                                {{ row.coordinator[0] === "" && ' - ' || row.coordinator[0] }}
                                <div @mouseover="coordinatorTooltip[index] = true" @mouseleave="coordinatorTooltip[index] = false" v-if="row.coordinator.length > 1" class="referent_plus">
                                    {{ `+${row.coordinator.length - 1}` }}
                                    <Tooltip 
                                        v-if="coordinatorTooltip[index]"
                                        color="#000"
                                        title="Coordinadores" 
                                        :list="row.coordinator"
                                    />
                                </div>
                            </td>
                            <td class="table__body__row__referent" v-if=" userData.role == 'COORDINADOR_PEDAGOGICO'">
                                {{ row.referent[0] === "" && ' - ' || row.referent[0] }}
                                <div @mouseover="referentTooltip[index] = true" @mouseleave="referentTooltip[index] = false" v-if="row.referent.length > 1" class="referent_plus">
                                    {{ `+${row.referent.length - 1}` }}
                                    <Tooltip 
                                        v-if="referentTooltip[index]"
                                        color="#000"
                                        title="Gestores" 
                                        :html="true" 
                                        :list="row.referent"
                                    />
                                </div>
                            </td>
                            <td class="table__body__row__status" ><span :class="`--${row.status}`">{{$t(`preInscription.status.${row.status}`)}}</span></td>
                            <td class="table__body__row__type">{{$t(`preInscription.preInscriptionTypes.${row.type}`)}}</td>
                            <td class="table__body__row__type">{{ row.targetType }}</td>
                            <td class="table__body__row__options" @click.stop="modalOptions == row.id ? modalOptions = null : modalOptions = row.id">
                                <div>
                                    <i class="material-icons">more_vert</i>
                                </div>
                            </td>
                            <div class="table__modal-options" v-if="modalOptions == row.id" @click.stop="''">
                                <div 
                                    @click.stop="row.status !== 'CLOSED' && router.push(`/editPreinscription/${row.id}`)" 
                                    :class="{'disabled': row.status === 'CLOSED'}">
                                    <i class="material-icons">mode</i>Editar
                                </div>
                                <div @click.stop="getExcel(row.id,row.title); modalOptions = null"><i class="material-icons">file_download</i>Descargar reporte</div>
                                <!-- <div @click.stop="copyToClipboard(row.linkStageOne)"><i class="material-icons">link</i>Obtener link etapa 1</div>
                                <div @click.stop="copyToClipboard(row.linkStageTwo)"><i class="material-icons">link</i>Obtener link etapa 2</div> -->
                                <div v-if="row.type !== 'ON_DEMAND'" @click.stop="copyToClipboard(row.linkCompleteForm)"><i class="material-icons">link</i>Obtener link completo</div>
                                <div @click.stop="changeStatus(row.id)">
                                    <i class="material-icons">check_circle_outline</i>
                                    {{row.manualStatus == 'PUBLISHED' ? 'Cerrar preinscripción' : 'Abrir preinscripción'}}
                                </div>
                                <div v-if="row.manualStatus !== 'CLOSED_COURSE_CREATION' && row.type !== 'ON_DEMAND'" @click.stop="router.push(`/createcourses/${row.id}`)"><i class="material-icons">add_circle_outline</i>Abrir curso</div>
                            </div>
        
                        </tr>
                    </tbody>
                    
                </table>
                <div v-if="!preinscriptions.length" style="width:1150px;padding:20px 0 20px 0;text-align:center">No hay resultados para mostrar...</div>
            </div>
            <div class="pagination" v-if="totalResults">
                <button class="prev-next" @click.stop="selectPage('prev')" :disabled="page == 0"><i class="material-icons">arrow_back</i><span>Anterior</span> </button>
                <div class="page"><span>{{ formattedPage }}</span>{{ formattedPages }}</div>
                <button class="prev-next" @click.stop="selectPage('next')" :disabled="page+1 == pages"><span>Siguiente</span> <i class="material-icons">arrow_forward</i></button>
            </div>
        </div>
        
    </div>
    <Loader v-else />

</template>

<script setup>
import { inject, onMounted, onBeforeUnmount, ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Loader from '@/components/Loader.vue';
import Tooltip from '@/components/ToolTip.vue'

const store = useStore();
const router = useRouter();
const formatDate = inject('formatDate');
const copyToClipboard = inject('copyToClipboard');
const userData = computed(() => store.getters.manageUser_user);
const creationOptions = ref();
const creationOptionsLoaded = ref(false);   
const modalOptions = ref(null)
const table = ref(null)
const preinscriptions = ref();
const dataLoaded = ref(false);
const stageTooltip = ref(null);
const coordinatorTooltip = ref({})
const referentTooltip = ref({})
const isDownloading = ref(false);
const expandFilter = ref('');
const page = ref(0);
const totalResults = ref();
const remainResults = ref();
const pages = ref();

const params = ref({
    rows: 5,
    forgeUserId: '',
    status: 'ALL',
    country: 0,
    courseType: '',
    targetType: ''
})

watch(
  () => params.value, 
  () => {
    page.value = 0;
    getPreinscriptions();
  }, 
  { deep: true }
);

const formattedPage = computed(() => {
    return 'Página ' + (page.value + 1 < 10 ? '0' + (page.value + 1) : page.value + 1);
});

const formattedPages = computed(() => {
    return ' / ' + (pages.value < 10 ? '0' + pages.value : pages.value);
});

async function getCreationOptions(){
    try {
        creationOptionsLoaded.value = false; 
        let req = await store.dispatch('preRegistration_creationOptions');
        creationOptions.value = req.data;
        creationOptions.value.countries.push({id: 0, name: 'Todos'})
        creationOptions.value.coordinators.push({id: '', fullName: 'Todos'})
        creationOptions.value.referents.push({id: '', fullName: 'Todos'})
        creationOptions.value.courseType.push({id: '', name: 'Todos'})
        creationOptions.value.targetType.push({id: '', name: 'Todos'})
        creationOptions.value.status = ['OPEN','CLOSED','FULL','PENDING_OPEN','ALL',]
        creationOptionsLoaded.value = true;                
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: 'Error al cargar opciones de filtros' });
    }
}

async function getExcel(id,name){
    try {
        isDownloading.value = true;
        let fileName = `inscripcion-${name}`.toUpperCase()
        await store.dispatch('preInscription_getExcel',{id: id, fileName: fileName }) 
        isDownloading.value = false;
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create',{text: 'Error al descargar archivo'});
        isDownloading.value = false;
    }
}

function selectPage(prevNext){
    if(prevNext == 'next') page.value++;
    else if(prevNext == 'prev') page.value--;
    getPreinscriptions()
}

async function changeStatus(id){
    try {
        modalOptions.value = null;
        await store.dispatch('preInscription_changeStatus',id);
        getPreinscriptions();
    } catch (error) {
        if (error.response.status == 400 && error.response.data == 'INVALID_COURSE_CLOSED_CREATION') {
            store.dispatch('notifications_create',{text: 'La inscripción no puede abrirse porque fue cerrada por la creación de cursos'});
        } else {
            console.log(error);
            store.dispatch('notifications_create',{text: 'Error al intentar cambiar el estado'});
        }
    }
}
        
const closeModals = (e)=> { 
    if(!e.target.matches('.table__modal-options')){
        modalOptions.value = null;
    }
    if(!e.target.matches('.filter') && !e.target.matches('.filter-label') && !e.target.matches('.filter-icon')){
        expandFilter.value = '';
    }
}

async function getPreinscriptions(){
    try {
        dataLoaded.value = false;
        let filters = { ...params.value };  
        filters.page = page.value;
        let req = await store.dispatch('preInscription_getPreinscriptions', filters);

        preinscriptions.value = req.data.data;
        totalResults.value = req.data.totalResults;
        remainResults.value = req.data.totalResults - (page.value * params.value.rows);
        pages.value = Math.ceil(req.data.totalResults / params.value.rows);
        dataLoaded.value = true;
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create',{text: 'Error al obtener preinscripciones'});
    }
}

onMounted(()=>{
    getPreinscriptions();
    getCreationOptions();
    document.addEventListener('click', closeModals);
    document.body.style.overflowX = 'auto';
    document.body.style.background = '#fff';
})
onBeforeUnmount(()=>{
    document.removeEventListener('click', closeModals);
    document.body.style.overflowX = 'visible';
    document.body.style.background = '';

})

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.referent{
    &_plus{
        font-weight: 700;
        font-size: 16px;
        color: $green;
    }
}
.table__modal-options{
    position: absolute;
    // top: 50px;
    right: 2px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    >div{
        padding: 4px 22px;
        @include icon-and-text-container;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        &:hover{
            background: rgba(189, 228, 228, 0.5);
        }
    }

    .disabled {
        cursor: not-allowed;
        opacity: 0.5;
    
    }
}

.preinscriptions{
    box-sizing: border-box;
    .new-preinscription{
        display: flex;
        align-items: center;
        gap: 36px;
        h3{
            font-size: 20px;
            line-height: 20px;
        }
        .create-new{
            padding-top: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 13px;
            color: $green;
            font-weight: 600;
            //border: 1px solid $green;
            border-radius: 24px;
            .material-icons{
                height: 16px;
                font-size: 16px;
                padding-bottom: 2px;
            }
        }
    }
    .filters{
        margin: 24px 0 16px 0;
        display: flex;
        justify-content: space-evenly;
        gap: 16px;
        .filter{
            position: relative;
            font-weight: 500;
            font-size: 13px;
            position: relative;
            width: 200px;
            padding: 6px 12px;
            border: 1px solid #212121;
            border-radius: 25px;
            span{
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            ul{
                position: absolute;
                width: 100%;
                top: 42px;
                left: 0;
                z-index: 4000;
                background: #fff;
                padding: 4px 12px;
                border: 1px solid #212121;
                border-radius: 12px;
                li{
                    padding: 0px 0;
                    margin: 8px 0;
                    cursor: pointer;

                }
            }
        }
    }

    .table-pagination {
        border-radius: 10px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    }
    @media (max-width: 980px) {
        .table__container {
            overflow-x: auto;
        }
    }
    .table {
        width: 100%;
        position: relative;
        margin-top: 8px;
        padding: 16px;
        padding-bottom: 0;

        th, td {
            padding: 14px;
        }

        &__head {           
            &__row {
                th {
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-weight: 600;
                    font-size: 12px;
                    text-align: left;    

                    &.table__head__row__options {
                        padding-right: 0;
                        padding-left: 0;
                    }
                    &.table__head__row__title {
                        padding-left: 0;
                    }                
                    &.table__head__row__stage {
                        position: relative;
                        overflow: visible;
                        .material-icons-outlined{
                            font-size: 12px;
                        }
                        .stage-tooltip{
                            width: 200px;
                            position: absolute;
                            // top: -28px;
                            right: -36px;
                            padding: 18px 14px 26px 14px;
                            background: #BDE4E4;
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            border-radius: 10px;
                            text-align: left;
                            font-size: 11px;
                            font-weight: 400;
                            z-index: 100;
                            h4{
                                padding-bottom: 4px;
                                font-size: 13px;
                                font-weight: 700;
                            }
                        }
                    }
                }
            }
        }

        &__body {
            tr {
                td {
                    max-width: 210px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 11px;
                    text-align: left;
                    border-bottom: 1px solid #eee;

                    &.table__body__row__title {
                        font-weight: 600;
                        font-size: 12px;
                        padding-left: 0;
                     
                        .title-tooltip {
                            width: 300px;
                            position: absolute;
                            left: 210px;
                            margin-top: -16px;
                            // padding: 18px 14px 26px 14px;
                            padding: 16px;
                            background: #BDE4E4;
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            border-radius: 10px;
                            text-align: left;
                            font-size: 11px;
                            font-weight: 400;
                            z-index: 100;
                            font-weight: 700;
                            text-wrap: wrap;
                        }
                    }

                    &.table__body__row__status {
                        // padding-top: 4px !important;
                        text-align: center;
                        span{
                            display: inline-block;
                            // width: 100px;
                            width: 100%;
                            padding: 4px 16px;
                            border-radius: 50px;
                            font-size: 12px;
                            font-weight: 600;
                            text-align: center;
                            &.--OPEN{
                                color: $green;
                                background: rgba(189, 228, 228, 0.5);
                            }
                            &.--CLOSED,&.--EXPIRED{
                                background: rgba(255, 189, 176, 0.5);
                                color: #FF5630;
                            }
                            &.--FULL{
                                background: #EFE2EE;
                                color: #9E5498;
                            }
                            &.--PENDING_OPEN{
                                color: #FFB23F;
                                background: rgba(255, 178, 63, 0.15);
                            }
                        }
                    }

                    &.table__body__row__type{
                        font-size: 11px;
                        font-weight: 600;	
                    }

                    &.table__body__row__options {
                        font-size: 12px;
                        font-weight: 600;
                        cursor: pointer;
                        // display: flex;
                        // align-items: center;
                        // justify-content: flex-end;
                        padding-left: 0;
                        padding-right: 0;
                        width: 28px;
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                        }          
                    }
                }
            }
        }

    }
    .pagination{
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 24px 16px;
        .prev-next{
            @include icon-and-text-container;
            font-size: 15px;
            font-weight: 600;
            color: $green;
            line-height: 20px;
            &:disabled{
                cursor: default;
            }
            .material-icons{
                font-size: 20px;
            }
        }
        .page{
            font-size: 15px;
            font-weight: 400;
            span{
                font-weight: 700;
            }
        }
    }
}


.loader-is-downloading {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(255,255,255,0.8);
    z-index: 10;
}
</style>